module.exports = __webpack_public_path__ + "img/shield.d671c88c.svg";